import axios from 'axios';

const BASE_URL = 'https://l1h00p9r1m.execute-api.us-east-1.amazonaws.com/v1';

export const post = (url, data, token) =>
	axios.post(`${BASE_URL}${url}`, data, { headers: { 'Content-Type': 'application/json', 'X-Auth-Token': token } });

export const get = (url, token) => axios.get(`${BASE_URL}${url}`, { headers: { 'X-Auth-Token': token } });

export const del = (url, id, token) =>
	axios.delete(`${BASE_URL}${url}`, { headers: { 'X-Notes-Id': id, 'X-Auth-Token': token } });
